import React, { useState, useEffect, useRef } from "react";
import { CircularProgress, Box, LinearProgress } from "@mui/material";

import { useNetwork } from "../../../context/NetworkContext";
import { useShowAlert } from "../../../context/AlertContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import Messages from "../../../constants/Messages";
import StateDropdown from '../../../constants/StateDropDown';
import uRLs from "../../../utils/baseUtils";
import { useAuth } from "../../../context/AuthProvider";
import { BuildingIcon, CheckIcon, EditIcon, EnvelopeIcon, HomeIcon, TelephoneIcon, XIcon } from "../../../constants/Icons";
const StoreControl = ({isEditMode,setIsEditMode}) => {
    const [isState, setSelectedState] = useState("");
    const [isStatecode, setSelectedStateCode] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [isBtnLoading, setBtnLoading] = useState(false);
    const [profileData, setProfileData] = useState(null);
    const [errors, setErrors] = useState({});
    const [initialProfileData, setInitialProfileData] = useState(null);
    const titleRef = useRef(null);
    const phoneRef = useRef(null);
    const emailRef = useRef(null);
    const additionalPhoneRef=useRef(null)
    const addressLine1Ref = useRef(null);
    const addressLine2Ref = useRef(null);
    const districtRef = useRef(null);
    const stateRef = useRef(null);
    const pincodeRef = useRef(null);
    const gstRef = useRef(null);
    const panRef = useRef(null);
    const cinRef = useRef(null);
    const fssaiRef = useRef(null);
    const buttonRef = useRef(null);

    const [croppedImageUrl, setCroppedImageUrl] = useState("/assets/images/avatars/default.jpg");
    const [uploadProgress, setUploadProgress] = useState(0);
    const [isUploading, setIsUploading] = useState(false);

    const { checkNetwork } = useNetwork();
    const showAlert = useShowAlert();
    const { handleUser } = useAuth();

    const handleView = async () => {
        setIsLoading(true);
        try {
            if (!checkNetwork()) return;
            const response = await AxiosInstance.get(`module/storeprofile/view-profile-details`);
             const profile = response.data.results;          
            setProfileData(profile);
            setInitialProfileData(profile);
            setSelectedState(profile.state);
            setSelectedStateCode(profile.statecode);
            if (profile.image) {
                setCroppedImageUrl(uRLs.IMAGE_URL+'profile/'+profile.image);
            }
        } catch (error) {
            handleError(error, showAlert);
            return false;
        } finally {
            setIsLoading(false);
        }
    };

    const hasChanges = () => {
    if (!initialProfileData || !profileData) return false;

    const fieldsToCheck = [
        "title", "email", "phone","additionalPhone", "addressline1", "addressline2",
        "pincode", "district", "state", "statecode", "country",
        "gstnumber", "pannumber", "cinnumber","fssai"
    ];

    return fieldsToCheck.some((field) => {
        const currentValue = profileData[field] || "";
        const initialValue = initialProfileData[field] || "";
        return currentValue.trim() !== initialValue.trim();
    });
};

    const handleChange = (e) => {
        const { name, value } = e.target;
        let inputValue = value;
          if (errors[name]) {
    setErrors(prev => {
      const newErrors = {...prev};
      delete newErrors[name];
      return newErrors;
    });
  }
  
        if (name === "phone" || name === "additionalPhone" || name === "pincode" || name==="fssai") {
             inputValue = value.replace(/\D/g, "");
        }
        const updatedData = {
            ...profileData,
            [name]: inputValue,
        };
        setProfileData(updatedData);
    };

    const handleStateChange = (e) => {
        setErrors("");
        const { value } = e.target;
        const label = e.target.options[e.target.selectedIndex].text;
        setSelectedStateCode(value);
        setSelectedState(label);
        setProfileData((prev) => ({ ...prev, "state": label, "statecode": value }));
    };

    const dataURItoBlob = (dataURI) => {
        const byteString = atob(dataURI.split(',')[1]);
        const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: mimeString });
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        try {
            setIsUploading(true);
            const reader = new FileReader();
            reader.onload = async (e) => {
                const img = new Image();
                img.src = e.target.result;

                img.onload = async () => {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    const aspectRatio = img.width / img.height;
                    const newHeight = 300;
                    const newWidth = aspectRatio * newHeight;
                    canvas.width = newWidth;
                    canvas.height = newHeight;
                    ctx.drawImage(img, 0, 0, newWidth, newHeight);
                    const resizedImage = canvas.toDataURL('image/png');
                    const blob = dataURItoBlob(resizedImage);

                    if (!checkNetwork()) return;
                    const formData = new FormData();
                    // formData.append('profileid', profileData._id);
                    formData.append('image', blob, 'logoimage.png');
                    try {
                        const response = await AxiosInstance.patch(`module/storeprofile/image/${profileData._id}`, formData, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            },
                            onUploadProgress: (progressEvent) => {
                                const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                                setUploadProgress(percentCompleted);
                            },
                        });

                        if (response.data.status === false) {
                            showAlert("error", Messages.ERROR.UPLOAD_FAILED);
                            return;
                        }

                        setCroppedImageUrl(uRLs.IMAGE_URL+'profile/'+response.data.results.image);
                        showAlert("success", Messages.SUCCESS.FILE_UPLOADED);
                        await handleUser();
                        setIsEditMode(false)
                    } catch (error) {
                        handleError(error, showAlert);
                        return false;
                    } finally {
                        setIsUploading(false);
                        setUploadProgress(0);
                    }
                };
            };
            reader.readAsDataURL(file);
        } catch (error) {
            handleError(error, showAlert);
            setIsUploading(false);
            setUploadProgress(0);
        }
    };

    const handleUpdate = async () => {
        setBtnLoading(true);
        try {
          if (!checkNetwork()) return;
          setErrors({});
           if (!profileData.title || profileData.title.trim() === "") {
            setErrors({ title: "Title is required" });
            if (titleRef?.current) titleRef.current.focus();
            return;
            }
            if (!profileData.phone || profileData.phone.trim() === "") {
            setErrors({ phone: "Phone number is required" });
            if (phoneRef?.current) phoneRef.current.focus();
            return;
            }
            const phoneRegex = /^\d{10}$/;
            if (!phoneRegex.test(profileData.phone.trim())) {
            setErrors({ phone: "Phone number must be 10 digits" });
            if (phoneRef?.current) phoneRef.current.focus();
            return;
            }
            if (!profileData.state || profileData.state.trim() === "Select") {
            setErrors({ state: "State is required" });
            if (stateRef?.current) stateRef.current.focus();
            return;
            }
          const validations = {         
            email: {
              regex: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
              error: "Invalid email format",
              ref: emailRef,
            },
            pincode: {
              regex: /^\d{6}$/,
              error: "Pincode must be 6 digits",
              ref: pincodeRef,
            },
            gstnumber: {
              regex:
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[0-9A-Z]{1}[Z]{1}[0-9A-Z]{1}$/,
              error: "Invalid GST number format",
              ref: gstRef,
            },
            pannumber: {
              regex: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
              error: "Invalid PAN number format (e.g., ABCDE1234F)",
              ref: panRef,
            },
            cinnumber: {
              regex: /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/,
              error: "Invalid CIN number format",
              ref: cinRef,
            },
            fssai: {
              regex: /^\d{14}$/,
              error: "FSSAI must be exactly 14 digits and contain only numbers.",
              ref: fssaiRef,
            },
          };
        //   const newErrors = {};
        //   let firstErrorField = null;

          for (const field in validations) {
              const { regex, error, ref } = validations[field];
              const value = profileData[field]?.trim();
              if (value && !regex.test(value)) {
               setErrors({ [field]: error });
               if (ref?.current) ref.current.focus();
                return;
            }
          }

      if (
      profileData.gstnumber &&
      profileData.gstnumber.trim() !== "" &&
      (!profileData.state || profileData.state.trim() === "")
    ) {
      setErrors({
        state: "State is required when GST number is provided",
      });
      if (stateRef?.current) stateRef.current.focus();
      return;
    } if (
      profileData.gstnumber &&
      profileData.gstnumber.trim() !== "" &&
      (!profileData.state || profileData.state.trim() === "")
    ) {
      setErrors({
        state: "State is required when GST number is provided",
      });
      if (stateRef?.current) stateRef.current.focus();
      return;
    }


          const validFields = [
            "title",
            "email",
            "phone",
            "additionalPhone",
            "addressline1",
            "addressline2",
            "pincode",
            "district",
            "state",
            "statecode",
            "country",
            "gstnumber",
            "pannumber",
            "cinnumber",
            "fssai"
          ];
          const dataToUpdate = {};
          validFields.forEach((field) => {
             dataToUpdate[field] = profileData[field]
             ? profileData[field].trim()
             : "";
          });
        // const dataToUpdate = {};
        // validFields.forEach((field) => {
        // const value = profileData[field]?.trim();
        // if (field === "fssai" && !value) return;

        // dataToUpdate[field] = value;
        // });
          if (Object.keys(dataToUpdate).length === 0) {
            showAlert("info", "No valid data to update");
            return;
          }
if (!dataToUpdate.country) {
           dataToUpdate.country = "India";
          }
          // const data = {
          //     ...profileData,
          //     // profileid: profileData._id
          // };
          const response = await AxiosInstance.put(
            `module/storeprofile/${profileData._id}`,
            dataToUpdate
          );
          const profile = response.data.results;
          setInitialProfileData(profile);
          setProfileData(profile);
          showAlert("success", Messages.SUCCESS.PROFILE_UPDATED);
          setIsEditMode(false)
        } catch (error) {
          handleError(error, showAlert);
          return false;
        } finally {
          setBtnLoading(false);
        }
    };

    const handleEnterFocus = (e, nextRef) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          nextRef?.current?.focus();
        }
      };

      const handleClose = () => {
  
    if (initialProfileData) {
        setProfileData(initialProfileData);
        setSelectedState(initialProfileData.state);
        setSelectedStateCode(initialProfileData.statecode);        
    }
      setIsEditMode(false)
};
      
    useEffect(() => {
        handleView();
    }, []);

    return (<>
        <Box position="relative">
            {isLoading && (
                <Box
                    position="absolute"
                    top={0}
                    left={0}
                    width="100%"
                    height="100%"
                    bgcolor="rgba(255, 255, 255, 0.5)"
                    display="flex"
                    justifyContent="center"
                    alignItems="center"
                    zIndex={1000}
                >
                    <CircularProgress size={22} />
                </Box>
            )}
            <div className="card ">
                <div className="card-header p-3 bg-light-core d-flex align-item-center justify-content-between">
                    <h6 className={`mb-0 text-dark  ${!isEditMode ? "mt-2 ":"mt-0"}`}>Store Details</h6>
                    {!isEditMode && (
                    <button
                        type="button"
                        className="btn  btn-primary mt-2 mt-lg-0"
                        onClick={() => setIsEditMode(true)}
                    >
                        <EditIcon iClass={"me-1"}/> Edit Profile
                    </button>
                )}
                </div>
              {isEditMode ? (<>
                <div className="card-body pb-0">
                    <div className="row g-3">
                        <div className="profile-picture p-2">
                            <div className="upload-profile me-3">
                                <div className="profile-img">
                                    <img
                                        id="logoimg"
                                        className="avatar"
                                        src={croppedImageUrl}
                                        alt="profile-img"
                                        style={{
                                            width: '100%',
                                            maxWidth: '100%',
                                            overFlow: 'hidden',
                                            objectFit: 'contain'
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="img-upload">
                                <label className="btn btn-sm btn-primary">
                                    {isUploading ? (
                                        <>
                                            Uploading <span className="spinner-border spinner-border-sm align-middle ms-1"></span>
                                        </>
                                    ) : (
                                        "Upload Logo"
                                    )}
                                    <input
                                        id="logo_image"
                                        type="file"
                                        accept="image/jpeg,image/png"
                                        onChange={handleImageChange}
                                        style={{ display: 'none' }}
                                        disabled={isUploading}
                                    />
                                </label>
                              
                                <p className="mt-2 mb-0">Supported File formats : JPG, JPEG, PNG. Max size of 1Mb</p>
                                { isUploading && (
                                    <Box sx={{ width: '100%', mt: 2 }}>
                                        <LinearProgress variant="determinate" value={uploadProgress} />
                                        <Box sx={{ textAlign: 'center', mt: 1 }}>
                                            Uploading: {uploadProgress}%
                                        </Box>
                                    </Box>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-header p-3 bg-light-core">
                    <h6 className="mb-0 text-dark">Contact Details</h6>
                </div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">Title </label>
                                <input
                                    ref={titleRef}
                                    type="text"
                                    className="form-control"
                                    name="title"
                                    autoComplete="off"
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,phoneRef)}
                                    value={profileData?.title || ""}
                                    autoFocus
                                />
                            </div>
                              {errors.title && (
                        <div className="error-message invalid-feedback">
                          {errors.title}
                        </div>
                      )}
                        </div>
                        <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                            <div className="input-block">
                                <label className="form-label">Phone </label>
                                <input
                                    ref={phoneRef}
                                    type="text"
                                    className="form-control"
                                    name="phone"
                                    autoComplete="off"
                                    maxLength={10}
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,additionalPhoneRef)}
                                    value={profileData?.phone || ""}
                                />
                                 {errors.phone && (
                        <div className="error-message invalid-feedback">
                          {errors.phone}
                        </div>
                      )}
                            </div>
                            
                        </div>
                         <div className="col-12 col-sm-6 col-md-4 col-lg-2">
                            <div className="input-block">
                                <label className="form-label">Additional Phone </label>
                                <input
                                    ref={additionalPhoneRef}
                                    type="text"
                                    className="form-control"
                                    name="additionalPhone"
                                    autoComplete="off"
                                    maxLength={10}
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,emailRef)}
                                    value={profileData?.additionalPhone || ""}
                                />
                                 {errors.phone && (
                        <div className="error-message invalid-feedback">
                          {errors.phone}
                        </div>
                      )}
                            </div>
                            
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">Email </label>
                                <input
                                    ref={emailRef}
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="email"
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,addressLine1Ref)}
                                    value={profileData?.email || ""}
                                />
                                          {errors.email && (
                        <div className="error-message invalid-feedback">
                          {errors.email}
                        </div>
                      )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-header p-3 bg-light-core">
                    <h6 className="mb-0 text-dark">Billing Address</h6>
                </div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">Addressline 1 </label>
                                <input
                                    ref={addressLine1Ref}
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="addressline1"
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,addressLine2Ref)}
                                    value={profileData?.addressline1 || ""}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">Addressline 2 </label>
                                <input
                                    ref={addressLine2Ref}
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="addressline2"
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,districtRef)}
                                    value={profileData?.addressline2 || ""}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">District </label>
                                <input
                                    ref={districtRef}
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="district"
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,stateRef)}
                                    value={profileData?.district || ""}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">State </label>
                                <StateDropdown ref={stateRef} onKeyDown={(e)=>handleEnterFocus(e,pincodeRef)} stateChange={handleStateChange} value={isStatecode} />
                            </div>
                             {errors.state && (
                        <div className="error-message invalid-feedback">
                          {errors.state}
                        </div>
                      )}
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">Country </label>
                                <input
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="country"
                                    onInput={handleChange}
                                    readOnly
                                    value={profileData?.country || "INDIA"}
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">Pincode </label>
                                <input
                                    ref={pincodeRef}
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="pincode"
                                    maxLength={6}
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,gstRef)}
                                    value={profileData?.pincode || ""}
                                />
                                  {errors.pincode && (
                        <div className="error-message invalid-feedback">
                          {errors.pincode}
                        </div>
                      )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-header p-3 bg-light-core">
                    <h6 className="mb-0 text-dark">Business Identifiers</h6>
                </div>
                <div className="card-body">
                    <div className="row g-3">
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">GST Number </label>
                                <input
                                    ref={gstRef}
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="gstnumber"
                                    onInput={(e) => {
                                        e.target.value = e.target.value.toUpperCase();
                                        handleChange(e);
                                    }}
                                    onKeyDown={(e)=>handleEnterFocus(e,panRef)}
                                    value={profileData?.gstnumber || ""}
                                />
                                  {errors.gstnumber && (
                        <div className="error-message invalid-feedback">
                          {errors.gstnumber}
                        </div>
                      )}
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">PAN Number </label>
                                <input
                                    ref={panRef}
                                    type="text"
                                    className="form-control"
                                    autoComplete="off"
                                    name="pannumber"
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,cinRef)}
                                    value={profileData?.pannumber || ""}
                                />
                                           {errors.pannumber && (
                        <div className="error-message invalid-feedback">
                          {errors.pannumber}
                        </div>
                      )}
                            </div>
                        </div>
                        <div className="col-lg-4 col-12">
                            <div className="input-block">
                                <label className="form-label">CIN Number </label>
                                <input
                                    ref={cinRef}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control"
                                    name="cinnumber"
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,fssaiRef)}
                                    value={profileData?.cinnumber || ""}
                                />
                                                  {errors.cinnumber && (
                        <div className="error-message invalid-feedback">
                          {errors.cinnumber}
                        </div>
                      )}
                            </div>
                        </div>
                         <div className="col-lg-4 col-12 mt-2">
                            <div className="input-block mb-0">
                                <label className=" d-flex align-items-center"><span>FSSAI Number</span> <span className="fssai-img ms-2">
                                    <img
                                        id="logoimg"
                                        className="fssai-img"
                                        src='/assets/images/fssai.png'
                                        alt="fssai"
                                        style={{
                                            width: '100%',
                                            maxWidth: '100%',
                                            overFlow: 'hidden',
                                            objectFit: 'contain'
                                        }}
                                    />
                                </span></label>
                                <input
                                    ref={fssaiRef}
                                    type="text"
                                    autoComplete="off"
                                    className="form-control"
                                    maxLength={14}
                                    name="fssai"
                                    onInput={handleChange}
                                    onKeyDown={(e)=>handleEnterFocus(e,buttonRef)}
                                    value={profileData?.fssai || ""}
                                />
                                                  {errors.fssai && (
                        <div className="error-message invalid-feedback">
                          {errors.fssai}
                        </div>
                      )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="card-footer p-3 border-0">
                    <button
                type="button"
                className="btn btn-outline-secondary text-left"
                onClick={handleClose}
              >
                <XIcon/> Close
              </button>
                    {isBtnLoading ? (
                        <button className="btn btn-primary pb-0 text-right" disabled>
                            <CircularProgress size={22} className="text-white" />
                        </button>
                    ) : (
                        <button
                            ref={buttonRef}
                            type="button"
                            className="btn btn-primary text-right"
                            onClick={handleUpdate}
                              disabled={!hasChanges()}
                        >
                            <CheckIcon/> Save Changes
                        </button>
                    )}
                </div></>
              ) : (
 
               <>
                <div className="card-body p-4">  
                    <div className="row align-items-center mb-4">
                    <div className="col-md-3 col-lg-2 text-center text-md-start mb-3 mb-md-0">
                        <div className="d-inline-block  p-2 rounded ">
                        <img
                            src={croppedImageUrl}
                            alt="Store Logo"
                            className="img-fluid"
                            style={{
                            maxHeight: "120px",
                            maxWidth: "100%",
                            objectFit: "contain"
                            }}
                        />
                        </div>
                    </div>

                    <div className="col-md-9 col-lg-10 text-center text-md-start">
                        <h6 className="fw-bold text-dark mb-1">{profileData?.title || "-"}</h6>
                        <p className="text-muted mb-1">
                        <EnvelopeIcon iClass={"me-2"}/>{profileData?.email || "-"}
                        </p>
                        <p className="text-muted mb-0">
                        <TelephoneIcon iClass={"me-2"}/>+91 {profileData?.phone || "-"} {profileData?.additionalPhone && (
                        <>, +91 {profileData.additionalPhone}</>
                        )}
                        </p>
                    </div>
                    </div>
                    <hr className="my-4 text-muted opacity-25" />    
                    <div className="row g-4">     
                    <div className="col-lg-6">
                        <div className="card h-100 border-0 shadow-sm bg-light-core" style={{ borderRadius: "10px" }}>
                        <div className="card-header bg-transparent border-0 pt-4 px-4 pb-1">
                            <h6 className="fw-bold text-secondary  tracking-wider font-14 mb-0 d-flex align-items-center">
                                <HomeIcon iClass={"fs-5 me-2"}/><span className="mt-1"> Billing Address</span></h6>
                        </div>
                        <div className="card-body px-4 pb-4">
                            <div className="text-dark lh-base">
                            <p className="fw-semibold mb-1">{profileData?.addressline1}</p>
                            {profileData?.addressline2 && <p className="text-muted mb-2">{profileData?.addressline2}</p>}
                            <p className="mb-0 text-muted">
                                {profileData?.district}, {profileData?.state} - <span className="fw-mono">{profileData?.pincode}</span>
                            </p>
                            <p className="small text-uppercase fw-bold text-secondary mt-2 mb-0">{profileData?.country}</p>
                            </div>
                        </div>
                        </div>
                    </div>
                    
                    <div className="col-lg-6">
                        <div className="card h-100 border-0 shadow-sm bg-light-core" style={{ borderRadius: "10px" }}>
                        <div className="card-header bg-transparent border-0 pt-4 px-4 pb-1">
                        <h6 className="fw-bold text-secondary tracking-wider font-14 mb-0 d-flex align-items-center">
                            
                            <BuildingIcon iClass={"fs-5 me-2 text-primary-core"}/>
                            <span className="mt-1">Business Identifiers</span>
                        </h6>
                        </div>
                        <div className="card-body px-4 pb-4">
                            <div className="row g-3">
                            <div className="col-sm-6">
                                <span className="text-muted d-block small text-uppercase">GST Number</span>
                                <span className="fw-bold text-dark font-mono">{profileData?.gstnumber || <span className="text-muted fw-normal意 text-opacity-50 italic">-</span>}</span>
                            </div>
                            <div className="col-sm-6">
                                <span className="text-muted d-block small text-uppercase">FSSAI Number</span>
                                <span className="fw-bold text-dark font-mono">{profileData?.fssai || <span className="text-muted fw-normal text-opacity-50 italic">-</span>}</span>
                            </div>
                            <div className="col-sm-6">
                                <span className="text-muted d-block small text-uppercase">PAN Number</span>
                                <span className="fw-bold text-dark font-mono">{profileData?.pannumber || <span className="text-muted fw-normal text-opacity-50 text-muted italic">-</span>}</span>
                            </div>
                            <div className="col-sm-6">
                                <span className="text-muted d-block small text-uppercase">CIN Number</span>
                                <span className="fw-bold text-dark font-mono">{profileData?.cinnumber || <span className="text-muted fw-normal text-opacity-50 text-muted italic">-</span>}</span>
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </div>            
                </>
             )}
            </div>          
        </Box>        
        </>

    );
};

export default StoreControl;